import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import Table, { IMassMailHistory } from "./Table";
import { Toast } from "primereact/toast";
import { IPermissionProps } from "../../models/Login";
import { SendMassMail } from "../massMail/SendMassMail";
import { EmailHistory } from "./EmailHistory";
import { EmailList } from "./EmailList";

const MassMailHistory = (permissions: IPermissionProps) => {
  const [tableData, setTableData] = useState<any[]>([]);
  const toast = useRef<any>(null);
  const [reload, setReload] = useState(false);
  const [openMail, setOpenMail] = useState(false);
  const [selectedMail, setSelectedMail] = useState<IMassMailHistory | null>(
    null,
  );
  const [openDetail, setOpenDetail] = useState(false);
  const [selectedHistoryId, setSelectedHistoryId] = useState<
    number | undefined
  >();

  const handleOpenEmailDetail = (row: IMassMailHistory) => {
    setSelectedHistoryId(row.history_ID);
    setOpenDetail(true);
  };

  const handleOpenMail = (row: IMassMailHistory) => {
    setSelectedMail(row);
    setOpenMail(true);
  };

  // const loadTableData = async () => {
  //   const response = await Fetch("", "GET", null, null, toast);
  //   if (response) {
  //     const data = await response.json();
  //     setTableData(data);
  //   }
  // };

  useEffect(() => {
    // loadTableData();
  }, [reload]);

  return (
    <>
      <EmailHistory
        open={openMail}
        hideDialog={() => setOpenMail(false)}
        toast={toast}
        existingMail={selectedMail}
      />
      
      <EmailList
        open={openDetail}
        hideDialog={() => setOpenDetail(false)}
        toast={toast}
        historyId={selectedHistoryId}
      />

      <Table
        tableData={tableData}
        setTableData={setTableData}
        toast={toast}
        permissions={permissions}
        reload={reload}
        setReload={setReload}
        onOpenMail={handleOpenMail}
        openDetail={handleOpenEmailDetail}
      />
      <Toast ref={toast} />
    </>
  );
};
export default MassMailHistory;
